import { render, staticRenderFns } from "./activityEditSemesterHolidays.html?vue&type=template&id=18ea1124&scoped=true&"
import script from "./activityEditSemesterHolidays.vue?vue&type=script&lang=js&"
export * from "./activityEditSemesterHolidays.vue?vue&type=script&lang=js&"
import style0 from "./activityEditSemesterHolidays.css?vue&type=style&index=0&id=18ea1124&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ea1124",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VCol,VDataTable,VRow,VSelect,VTextField,VTreeview})
